import { useEffect } from "react";

import { publicEnv } from "@/env/public-env";

const gtmId = publicEnv.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

function initializeGtm() {
  if (gtmId) {
    import("react-gtm-module").then(({ default: TagManager }) => {
      TagManager.initialize({
        gtmId: gtmId,
      });
    });
  }
}

export default function useGoogleTagManager() {
  useEffect(() => {
    setTimeout(initializeGtm, 1000); // do not race app resources
  }, []);
}
